export default function ProgressLoader(props) {
  return (
    <>
      <div className="loading-blocker">
        <div className="loading-spinner">
          <div className="loader" />
        </div>
      </div>
    </>
  );
}

export function ProgressLoaderSimple() {
  return (
    <div className="loading-spinner">
      <div className="loader" />
    </div>
  );
}

/**
 * @param {*} message pass a string to display next to the loading dots - not required 
 * @returns a simple 3 dots loader with an optional text message inline, allows to use localized, does not block the whole page background
 */
export function LoadingDots({message=""}) {
  return (
    <div className="loading-dots">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="msg">{message}</div>
    </div>
  );
}

